import { render } from "./Button.vue?vue&type=template&id=c2cf1800&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=c2cf1800&lang=sass&scoped=true"

import exportComponent from "/opt/build/repo/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2cf1800"]])

export default __exports__